export const PASSENGER_TYPES = {
  ADULT: "ADT",
  CHILD: "CHD",
  INFANT: "INF",
} as const;

export type PassengerType = (typeof PASSENGER_TYPES)[keyof typeof PASSENGER_TYPES];
